export default __webpack_public_path__ + "static/media/746385259930714203.1bf690c8.png";